import React from "react";

class BuyMeACoffee extends React.Component {
    constructor(props) {
        super(props);

        let script = document.createElement("script");
        script.setAttribute("data-name", "BMC-Widget");
        script.src = "https://cdnjs.buymeacoffee.com/1.0.0/widget.prod.min.js";
        script.setAttribute("data-id", "tombstoneghost");
        script.setAttribute("data-description", "Support me on Buy me a coffee!");
        script.setAttribute("data-message", "");
        script.setAttribute("data-color", "#FFDD00");
        script.setAttribute("data-position", "Right");
        script.setAttribute("data-x_margin", "18");
        script.setAttribute("data-y_margin", "18");
        script.async = true;

        script.onload = function () {
            const evt = document.createEvent('Event');
            evt.initEvent('DOMContentLoaded', false, false);
            window.dispatchEvent(evt)
        }

        this.script = script;
    }

    componentDidMount () {
        document.head.appendChild(this.script)
    }

    componentWillUnmount() {
        document.head.removeChild(this.script);
        document.body.removeChild(document.getElementById("bmc-wbtn"))
    }

    render() {
        return null
    }
}

export default BuyMeACoffee;
